import { render, staticRenderFns } from "./AppPanels.vue?vue&type=template&id=189a92e5&scoped=true"
import script from "./AppPanels.vue?vue&type=script&lang=js"
export * from "./AppPanels.vue?vue&type=script&lang=js"
import style0 from "./AppPanels.vue?vue&type=style&index=0&id=189a92e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a92e5",
  null
  
)

export default component.exports